APP.BillList = (/** @lends APP.BillList */function () {
	'use strict';

	var exports,
		$body,
		inited = false,
		paymentIds = [];

	function init() {
		$body = APP.Performance.getCachedDOM().$body;

		if ($body.find('[data-advance-payment]')) {
			setAdvancePayment();
		}

		if (inited === false) {
			initBindings();
		}

		if (!$body.find('[data-bill-list]').length && !$body.find('[data-open-bills]').length) {
			return false;
		}

		if ($body.find('[data-open-bills]').length) {
			setOpenBillPayments();
		}

		inited = true;
	}

	function initBindings() {
		$body.on({
			change: function (e) {
				e.preventDefault();
				e.stopPropagation();
				collectPaymentAmounts();
			}
		}, '[data-bill-list-pay-amount]');

		$body.on({
			change: function (e) {
				e.preventDefault();
				e.stopPropagation();
				setAdvancePayment();
			}
		}, '[data-advance-payment] select');
	}

	function collectPaymentAmounts() {
		var amount, id,
			summary;

		paymentIds = [];
		summary = 0;

		$body.find('[data-bill-list-pay-amount]:checked').each(function () {
			amount = parseInt($.trim($(this).attr('data-bill-list-pay-amount')).replace(/\s|Ft/ig, ''), 10);
			summary += amount;
			id = $(this).attr('data-bill-list-billnumber');
			paymentIds.push(id);
		});

		setPaymentParameters(paymentIds, summary);
	}

	function setOpenBillPayments() {
		$body.find('[data-bill-list-paybutton]').each(function () {
			setPaymentParameters(false, false, true, $(this));
		});
	}

	function setAdvancePayment() {
		$body.find('[data-bill-list-paybutton-advance]').each(function () {
			setAdvancePaymentParameters($(this));
		});
	}

	function setAdvancePaymentParameters($item) {
		var $button = $item,
			originalParams = $button.attr('data-placeholder-click'),
			months,
			$select = $button.parents('[data-ref~="credit-module"]').find('[data-advance-payment] select'),
			validParams;

		months = parseInt($select.val(), 10);

		validParams = originalParams
			.replace(/{month}/ig, months)
			.replace(/{advanceText}/ig, $select.find('option:selected').text());

		$button.attr('data-click', validParams);
	}

	function setPaymentParameters(paymentIds, summary, isSingle, $item) {
		var $button = isSingle ? $item : $body.find('[data-bill-list-paybutton]'),
			originalParams = $button.attr('data-placeholder-click'),
			urlParams = paymentIds && paymentIds.join('|') || false,
			formattedAmount,
			showWarningForBill,
			showMinimumWarning,
			formattedIds = paymentIds && paymentIds.join('<br>') || '',
			rawSummary,
			rawId,
			validParams;

		if (isSingle) {
			rawSummary = $item && $item.attr('data-bill-list-amount') || 0;
			rawId = $item && $item.attr('data-bill-list-id') || 0;
			formattedAmount = rawSummary;
			rawSummary = parseInt(rawSummary.replace(/\s/ig, ''), 10);
		} else {
			rawSummary = summary;
			formattedAmount = summary.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ') + ' Ft';
		}

		showWarningForBill = checkLastPaymentIds(isSingle ? [rawId] : paymentIds);
		showMinimumWarning = checkMinimumPayment(rawSummary);

		validParams = originalParams
			.replace(/{amountPlaceholder}/ig, formattedAmount)
			.replace(/{billNumbers}/ig, urlParams)
			.replace(/{billNumbersFormatted}/ig, formattedIds)
			.replace(/{multipleIds}/ig, isSingle ? 0 : 1)
			.replace(/{showMinimumWarning}/ig, showMinimumWarning)
			.replace(/{showWarningForBill}/ig, showWarningForBill);

		if (rawSummary > 0) {
			$button.attr('data-click', validParams).removeClass('button--disabled');
		} else {
			$button.removeAttr('data-click').addClass('button--disabled');
		}

		$body.find('[data-bill-list-formatted-amount]').html(formattedAmount);
	}

	function checkLastPaymentIds(ids) {
		var showWarning = 0,
			$lastIdItem = $body.find('[data-bill-list-showWarningForBill]'),
			lastId = $lastIdItem && $lastIdItem.attr('data-bill-list-showWarningForBill') || false;

		if (lastId && ids.indexOf(lastId) === -1) {
			showWarning = 1;
		}

		return showWarning;
	}

	function checkMinimumPayment(summary) {
		var showWarning = 0,
			$minimumAmount = $body.find('[data-bill-list-invoiceMinAmount]'),
			minimumAmountValue = $minimumAmount && $minimumAmount.attr('data-bill-list-invoiceMinAmount') || false;

		if (minimumAmountValue && parseInt(minimumAmountValue, 10) > summary) {
			showWarning = minimumAmountValue;
		}

		return showWarning;

	}

	function billsResponse(e) {
		if(e.success === true) {
			APP.Overlay.setContent('' +
				'<span class="block block--margin-bottom text text--size-18">' +
				'<h1 class="text--size-18 text--color-text-grey block--margin-bottom-half">' +
				e.dialog.title +
				'</h1><div class="hr-gradient hr-gradient--small hr-gradient--grey hr-gradient--no-margin"></div><br>' +
				e.dialog.text +
				'</span>' +
				'<button data-close-overlay class="button block--full-width">Ok</button>', true, false, 'regular-bills-response');
			APP.Overlay.open();
		}
	}


	function handleRegularBillRequest() {
		var $element = $('[data-regular-bill-request]'),
			$switch = $element.find('[data-ref="regular-bills-switch"]'),
			$saveButton = $element.find('[data-ref="regular-bills-save"]');

		$switch.on('change', function() {
			var initVal = $switch.data('init-value');

			if ($switch.is(':checked') !== initVal) {
				$saveButton.removeAttr('disabled');

				if (initVal) {
					$saveButton.attr('data-click', 'open-overlay-with-tpl:{"tpl":"confirm-cancel-regular-bills"}');
				}

			} else {
				$saveButton.attr('disabled', 'disabled');
				$saveButton.removeAttr('data-click');
			}
		});

		$body.on('click.close-overlay', '[data-close-overlay]', function (e) {
			if($(e.target).parents('.regular-bills-response').length) {
				window.location.href = '/telefonszam/szamlak';
			}
		});
	}

	exports = {
		init: init,
		billsResponse: billsResponse,
		handleRegularBillRequest: handleRegularBillRequest
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
